export default __webpack_public_path__ + "static/media/add_buddy.81a070be.svg";